import { LicenseCheckType } from "../validators/driverValidators";

export type Driver = {
  companyId?: string;
  reservationId?: string;
  orderNum?: number;
  driverName?: string;
  tel?: string;
  address?: string; 
  birthday?: string;
  licenseType?: string;
  licenseNum: string;
  licenseDate?: string;
  singImg?: string;
  licenseFileGroupId?: string;
  emContactNumber?: string;
  licenseCerti?: boolean;
  groupName?: string;
  groupType?: string;
  regDtm?: number;
  licenseFileList?: Array<any>;
  fileId?: string;
  driverDirect?: boolean,
  needCheckCareer: LicenseCheckType[], // 25.02.25. 운전경력 현장 확인 필요 여부 추가
  isAdminManualCheck?: boolean, // 25. 03. 17 운전경력 현장 확인 완료 여부
  licenseCheckDtm?: string,
  licenseSystemError?: boolean,
  memberRegFlag?: boolean
};

const formatDate = (birthday: string): string => {
  if (birthday.length !== 6) {
    return birthday;
  }

  const year = birthday.slice(0, 2);
  const month = birthday.slice(2, 4);
  const day = birthday.slice(4, 6);

  const currentYear = new Date().getFullYear();
  const fullYear =
    parseInt(year) + (parseInt(year) >= currentYear % 100 ? 1900 : 2000); // 1900년과 2000년도 구분

  return `${fullYear}-${month}-${day}`;
};

export const defaultDriver: Driver[] = [
  {
    companyId: "",
    reservationId: "",
    orderNum: 0,
    driverName: "",
    tel: "",
    address: "",
    birthday: formatDate(""),
    licenseType: "",
    licenseNum: "",
    licenseDate: "",
    emContactNumber: "",
    licenseFileGroupId: "",
    groupName: "",
    groupType: "",
    regDtm: 0,
    fileId: "",
    licenseCerti: false,
    singImg: "",
    licenseFileList: [],
    driverDirect: false,
    needCheckCareer: [], // 25.02.25. 운전경력 현장 확인 필요 여부 추가
    isAdminManualCheck: false, // 25. 03. 17 운전경력 현장 확인 완료 여부
    licenseCheckDtm: "",
    licenseSystemError: false,
    memberRegFlag: false
  },
];

export interface DriverInfo {
  companyId?: string;
  reservationId?: string;
  orderNum?: number,
  driverName: string;
  licenseType: string;
  licenseNum: string;
  licenseCerti: boolean;
  tel: string;
  address?: string;
  birthday: string;
  emContactNumber: string;
  fileId: string;
  singImg?: string
  driverDirect?: boolean,
  needCheckCareer: LicenseCheckType[], // 25.02.25. 운전경력 현장 확인 필요 여부 추가
  isAdminManualCheck?: boolean, // 25. 03. 17 운전경력 현장 확인 완료 여부
  licenseFileGroupId?: string
  licenseCheckDtm?: string
  licenseSystemError?: boolean
  licenseFileList?: Array<any>,
  [key: string]: any;
  memberRegFlag?: boolean;
}

export const initialDriverInfo: DriverInfo = {
  licenseCerti: false,
  companyId: "",
  reservationId: "",
  orderNum: 0,
  driverName: "",
  licenseType: "",
  licenseNum: "",
  tel: "",
  address: "",
  birthday: formatDate(""),
  emContactNumber: "",
  fileId: "",
  singImg: "",
  driverDirect: false,
  needCheckCareer: [], // 25.02.25. 운전경력 현장 확인 필요 여부 추가
  isAdminManualCheck: false, // 25. 03. 17 운전경력 현장 확인 완료 여부
  LicenseFileGroupId: "",
  licenseCheckDtm: "",
  licenseSystemError: false,
  licenseFileList: [],
  memberRegFlag: false
};
// export const initialDriverInfo: DriverInfo = {
//   licenseCerti: false,
//   companyId: "",
//   reservationId: "",
//   orderNum: 0,
//   driverName: "방기범",
//   licenseType: "",
//   licenseNum: "131163297451",
//   tel: "01045562242",
//   birthday: formatDate("900920"),
//   emContactNumber: "01045562242",
//   fileId: "",
//   singImg: "",
//   driverDirect: false
// };


export type DriverValidTypes = {
  licenseNo: string;
  residentName: string;
  residentDate: string
  seqNo?: string;
  licenseConCode: string;
  fromDate: Date;
  toDate: Date
}

export type DriverValidResponse = {
  result: string;
  isValidVehicle: boolean;
  message: string
}

